import {currentUserHasUploadAccess} from '@netx/core-permissions-next/enablers/currentUserHasUploadAccess';

export const canUploadAssets = (): boolean => currentUserHasUploadAccess();
